module.exports = __webpack_public_path__ + "src/img/tel.79f3bf26.svg";